"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoPost = exports.Memo = void 0;
class Memo {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created Memo object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Memo = Memo;
class MemoPost extends Memo {
}
exports.MemoPost = MemoPost;
//# sourceMappingURL=Memo.js.map